/* eslint-disable import/prefer-default-export */
import axiosInstance from '../axios.instance';

export const getAllCategories = () => axiosInstance.get('/category/all');
